import {gsap, lenis} from "../utils/vendor.js";

let container, filters = [];

function onClick(event) {
    const isActive = event.currentTarget.closest("li").classList.contains("is-active");
    const url = isActive ? event.currentTarget.closest("ul").dataset.indexUrl : event.currentTarget.dataset.url;

    // Fix .is-active
    filters.forEach(span => {
        span.closest("li").classList.remove("is-active");
    });

    if (!isActive) {
        event.currentTarget.closest("li").classList.add("is-active");
    }

    // Sposto lo scroll della pagina
    lenis.scrollTo(container, {offset: -50});

    historyPush(url);
    go(url);
}

function historyPush(url) {
    let state = {
        name: "projects-filters",
        url: url,
    };

    window.history.pushState(state, "", url);
}

function historyPop(event) {
    if (event?.state?.name === "projects-filters" && event?.state?.url) {
        go(event.state.url);
    }
}

function go(url) {
    const selector = ".js-filters-content";
    const content = document.querySelector(selector);

    if (!content) {
        return;
    }

    const tweenOptions = {
        opacity: 0,
        y: 50,
        stagger: 0.05,
        duration: 0.2,
    };

    function load() {
        return fetch(url)
            .then(response => response.text())
            .then(html => {
                // Trucco banale: prendo il codice HTML della pagina, lo inserisco in un <div> temporaneo,
                // seleziono il frammento che mi interessa e lo sostituisco a quello della pagina corrente.
                let temp = document.createElement("DIV");
                temp.innerHTML = html;

                return temp.querySelector(selector).innerHTML;
            });
    }

    function leave() {
        return gsap.to(content.querySelectorAll(".c-case"), tweenOptions);
    }

    Promise.all([load(), leave()]).then(results => {
        content.innerHTML = results[0];

        // Il CSS imposta [data-fade] { opacity: 0 } in attesa che lo ScrollAnimationsComponent
        // lo animi al fade-in. Dopo la sostituzione di innerHTML il nuovo wrapper non è più
        // registrato in nessuna timeline GSAP, quindi lo forziamo allo stato visibile.
        gsap.set(content.querySelectorAll("[data-fade]"), {opacity: 1, x: 0, y: 0});

        return gsap.from(content.querySelectorAll(".c-case"), tweenOptions);
    });
}

export default class FiltersComponent {
    init() {
        container = document.querySelector(".js-filters");

        if (container) {
            filters = container.querySelectorAll("span");

            filters.forEach(span => {
                span.addEventListener("click", onClick);
            });

            window.addEventListener("popstate", historyPop);
        }
    }
}
